const roninApp = {
    init: true,
};

let raiBottomObserver = (() => {
    let raiElements = document.querySelectorAll('*[class*="rai-"]');
    let observer = new IntersectionObserver((entries) => {
            entries.forEach(entry => {
                let active = entry.isIntersecting;
                entry.target.classList.toggle('rai-on', active)
                entry.target.classList.remove('rai-off');
                if (entry.isIntersecting) observer.unobserve(entry.target);
            });
        },
        { 
            threshold: 0,
            rootMargin: '0px 0px 500px 0px',
        }
    );
    raiElements.forEach((element) => { 
        element.classList.add('rai-off');
        observer.observe(element);
    });
})();

/*============================================================================*/
roninApp.recomendadorOpciones = {
    "running-cmd": ['Biontech Running Champion'],
    "running-ld": ['Biontech Trail Running Platino'],
    "trailRunning": ['Biontech Trail Running Platino'],
    "ciclismo": ['Biontech Ciclismo Superlight'],
    "tenis": ['Biontech Pádel Tenis'],
    "senderismo-trekking": ['Biontech Senderismo Xtreme'],
    "padel": ['Biontech Pádel Tenis'],
    "gym": ['Biontech CrossFit Pro'],
    "crossfit": ['Biontech CrossFit Pro'],
    "futbol": ['Biontech Fútbol Energy'],
    "futbol-sala": ['Biontech Baloncesto Indoor Pro'],
    "baloncesto": ['Biontech Baloncesto Indoor Pro'],
    "trabajo": ['Biontech Trabajo Work Pro'],
    "vida": ['Confort Pro 2.0'],
};
let updateDataREC = (currentItemid, element, nextId) => {
    let selectorOpcionesActivas = '#' + currentItemid + ' .opcion.active';
    let actividades = [];
    let objetivos = [];
    let currentItem = document.getElementById(currentItemid);
    let selectorItems = '#' + currentItemid + ' .opcion';
    let items = document.querySelectorAll(selectorItems);
    let opcionesActivas = document.querySelectorAll(selectorOpcionesActivas);
    if (typeof roninApp.recomendador === 'undefined') {
        roninApp.recomendador = {
            tipoActividad: [],
            actividad: [],
            tipoObjetivo: [],
            objetivo: [],
            plantillas: [131],
        }
    }
    if (currentItem.classList.contains('multiselect')) {
        if (opcionesActivas.length < 3) {
            element.classList.toggle('active');
        } else {
            if (element.classList.contains('active')) {
                element.classList.remove('active');
            } else {
                alert('No puedes seleccionar más de 3 opciones');
            }
        }
    } else {
        items.forEach((item, i) => {
            item.classList.remove('active');
        });
        element.classList.add('active');
        if (nextId != '') {
            currentItem.setAttribute('data-next-id', nextId);
        }
    }
    if (currentItemid == 'step-1') {
        roninApp.recomendador.tipoActividad =
            [element.id];
    }
    if (currentItemid == 'step-11' || currentItemid == 'step-12') {
        roninApp.recomendador.actividad = [element.id];
    }
    if (currentItemid == 'step-110' || currentItemid == 'step-120') {
        roninApp.recomendador.tipoObjetivo = [element.id];
    }
    if (currentItemid == 'step-1101' || currentItemid == 'step-1102' || currentItemid == 'step-1201' || currentItemid == 'step-1202') {
        roninApp.recomendador.objetivo = [];
        opcionesActivas = document.querySelectorAll(selectorOpcionesActivas);
        opcionesActivas.forEach((item, i) => {
            roninApp.recomendador.objetivo.push(item.id);
        });
    }
    roninApp.recomendador.plantillas = roninApp.recomendadorOpciones[roninApp.recomendador.actividad[0]];
    if (!currentItem.classList.contains('multiselect')) {
        nextREC(currentItemid, 'next');
    }
    if (document.querySelector('.item-rec.current')) {
        document.querySelector('.item-rec.current').scrollIntoView({ behavior: "smooth", block: "start", inline: "center" });
    }
}
let nextREC = (currentItemid, action) => {
    let selectorOpciones = '#' + currentItemid + ' .opcion';
    let selectorOpcionesActivas = '#' + currentItemid + ' .opcion.active';
    let selectorItems = '.recomendador .item-rec';
    let selectorCurrentItem = '.recomendador .item-rec.current';
    let opciones = document.querySelectorAll(selectorOpciones);
    let opcionesActivas = document.querySelectorAll(selectorOpcionesActivas);
    let currentItem = document.querySelector(selectorCurrentItem);
    let nextItem = document.getElementById(currentItem.getAttribute('data-next-id'));
    let prevItem = document.getElementById(currentItem.getAttribute('data-prev-id'));
    if (action == 'next' && opciones.length > 0 && opcionesActivas.length < 1) {
        alert('Debes seleccionar al menos una opciÃ³n');
    } else {
        let items = document.querySelectorAll(selectorItems);
        items.forEach((item, i) => {
            item.classList.remove('current');
        });
        switch (action) {
            case 'prev':
                prevItem.classList.add('current');
                break;
            default:
                nextItem.classList.add('current');
        }
    }
    currentItem = document.querySelector(selectorCurrentItem);
    if (currentItem.id == 'step-100002') {
        setTimeout(()=>{
            recomendarProducto(roninApp.recomendador.plantillas[0]);
        }, 500);
        /*
        let recomendado1 = document.getElementById('recomendado_1');
        let productos1 = recomendado1.querySelector('.products');
        fetch(prestashop.urls.base_url + 'ronin/data/json-app.json')
            .then(response => response.json())
            .then(data => {
                let productosREC = data.data['pmini-HTML'];
                window.setTimeout(() => {
                    productos1.innerHTML = productosREC['pm_' + roninApp.recomendador.plantillas[0]];
                }, 1500);
            }
            );
        //Enviamos resultado a un EP del ronin para recoger los datos
        let recomendadorObject = roninApp.recomendador;
        let recomendadorJSON = JSON.stringify(recomendadorObject);
        let recomendadorData = new FormData();
        recomendadorData.append('roninAppRecomendador', recomendadorJSON);
        fetch(prestashop.urls.base_url + 'ronin/ronin?roninType=resultadosRecomendador', { method: "POST", body: recomendadorData })
            .then(response => response.json())
            .then(data => {
                //console.log(data.recomendadorActividades);
            }
        );
        */
    }
}
let updateContador = (contador) => {
    let contadorCurrent = contador.getAttribute('data-current');
    let contadorHasta = contador.getAttribute('data-hasta');
    let diferencia = parseInt(contadorHasta) - parseInt(contadorCurrent);
    if (diferencia > 0) {
        if (diferencia > 100) {
            contadorCurrent = parseInt(parseInt(contadorCurrent) + 25);
        } else if (diferencia > 50) {
            contadorCurrent = parseInt(parseInt(contadorCurrent) + 9);
        } else if (diferencia > 7) {
            contadorCurrent = parseInt(parseInt(contadorCurrent) + 2);
        } else {
            contadorCurrent = parseInt(parseInt(contadorCurrent) + 1);
        }
        contador.innerHTML = contadorCurrent;
        contador.dataset.current = contadorCurrent;
    }
}
let initContador = (contador) => {
    setInterval(() => {
        updateContador(contador);
    }, 20);
}
/*============================================================================*/
async function recomendarProducto(actividad) {
    const targetContainer = document.getElementById('producto_recomendado');
    if (!targetContainer) {
        console.error('No se encontró el contenedor #producto_recomendado');
        return;
    }
    try {
        const response = await fetch('/collections/all');
        const htmlText = await response.text();
        const parser = new DOMParser();
        const doc = parser.parseFromString(htmlText, 'text/html');
        const products = doc.querySelectorAll('.grid__item, .product-card');
        if (products.length > 0) {
            let productoSeleccionado = false;
            products.forEach(product => {
                let title = product.querySelector('.product-card__title');
                if(!productoSeleccionado && title && title.innerHTML.toLowerCase().includes(actividad.toLowerCase())){
                    targetContainer.appendChild(product.cloneNode(true));
                    productoSeleccionado = true;
                    document.getElementById('recomendados').remove();
                }
            });
            //console.log(`${products.length} productos insertados con éxito.`);
        } else {
            //console.warn('No se encontraron productos con la clase especificada.');
        }
    } catch (error) {
        console.error('Error al obtener los productos:', error);
    }
}
/*============================================================================*/

